var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Header'),_c('b-container',{staticClass:"page-hero-holder"},[_c('PageImage',{attrs:{"image":_vm.image,"title":_vm.title}})],1),_c('div',{staticClass:"page-content"},[_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }